export const ORIGIN_TRANSLATION = "translation"
export const ORIGIN_UPDATES = "updates"
export const ORIGIN_INTEGRATION = "integration"